import { combineReducers, createReducer } from '@reduxjs/toolkit';

import { setProductData } from 'Core/actions/product';
import { fromPayload } from 'Core/reducers/common';
import type { ServerModel } from 'Modules/serverApi/types';

export default combineReducers({
  data: createReducer<ServerModel.SearchItem | null>(null, (builder) =>
    builder.addCase(setProductData, fromPayload),
  ),
});
